import { useState, useEffect } from 'react';
import { buildApiUrl } from '../services/api';

export const useFetch = (url) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      try {
        setLoading(true);
        const requestUrl = buildApiUrl(url);
        console.log(`[useFetch] Fetching: ${requestUrl}`);

        const response = await fetch(requestUrl);
        console.log(`[useFetch] Response status: ${response.status}`);

        if (!response.ok) {
          const text = await response.text();
          console.error(`[useFetch] Response not OK:`, text);
          throw new Error(`HTTP ${response.status}: ${text.substring(0, 200)}`);
        }

        const contentType = response.headers.get('content-type');
        if (!contentType || !contentType.includes('application/json')) {
          const text = await response.text();
          console.error(`[useFetch] Invalid content type: ${contentType}`, text);
          throw new Error(`Invalid content type: ${contentType}`);
        }

        const result = await response.json();
        console.log(`[useFetch] Data received:`, result);

        if (isMounted) {
          setData(result.data || result);
          setError(null);
        }
      } catch (err) {
        console.error(`[useFetch] Error:`, err);
        if (isMounted) {
          setError(err.message || 'An error occurred');
          setData(null);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    if (url) {
      fetchData();
    }

    return () => {
      isMounted = false;
    };
  }, [url]);

  return { data, loading, error };
};
